import { observer } from "mobx-react-lite";
import React from "react";

const ClientRequestInfo = ({
  onSelectCurrency,
  newConversion,
  updateBudget,
  toggleUpdateBtn2,
  typing,
  requestSubjects,
  totalBudget,
  selectCurrency,
  hourlyBudget,
  toggleShowAllTutorDetails,
  rightText = "Hourly Budget",
  showAllDetail,
  aText = "/hr",
  splitCount,
  updateSplitType,
  teachAllSubjects,
  convertedTotalBudget,
}: any) => {
  return (
    <div
      className="row request-client-info"
      style={{ margin: "", padding: "16px" }}
    >
      <div className="col-sm-4 pd-right--0">
        <div>
          <strong>Subjects:</strong> {requestSubjects}
        </div>
      </div>
      <div className="col-sm-2 pd-left--0">
        <strong>Total Budget:</strong> ₦{totalBudget}
        {selectCurrency === "₦" ? null : (
          <div>
            {selectCurrency}{newConversion ? newConversion : convertedTotalBudget}
          </div>
        )}
        <form onSubmit={updateBudget}>
          <div className="input-group">
            <input
              defaultValue={totalBudget}
              name="budget"
              style={{ width: "90px", marginRight: "10px" }}
              type="number"
              className=""
              onFocus={() => toggleUpdateBtn2(true)}
              title="update the budget for this request"
            />
            {typing ? (
              <button className="btn btn-success btn-sm ft-14" type="submit">
                Update
              </button>
            ) : null}
          </div>
        </form>
      </div>
      <div className="col-sm-2 pd-left--0">
        <strong>Select Currency:</strong>
        <select value={selectCurrency} onChange={onSelectCurrency}>
          <option value="">Select</option>
          <option value="₦">NGN</option>
          <option value="$">USD</option>
          <option value="£">GBP</option>
          <option value="C$">CAD</option>
        </select>
      </div>
      <div className="col-sm-2 pd-left--0">
        <div>
          <strong>{rightText}:</strong> ₦{hourlyBudget}
          {aText}
        </div>
        {/* {teachAllSubjects && ( */}
        <div>
          <strong>Split type:</strong>{" "}
          <select defaultValue={splitCount} onChange={updateSplitType}>
            <option value="">Select</option>
            <option value={1}>Single</option>
            <option value={2}>Multiple</option>
          </select>
        </div>
        {/* )} */}
      </div>
    </div>
  )
};

export default observer(ClientRequestInfo);
